// Helper
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

const debounce = (func, delay) => {
    let inDebounce;
    return function() {
        const context = this;
        const args = arguments;
        clearTimeout(inDebounce);
        inDebounce = setTimeout(() => func.apply(context, args), delay)
    }
};

$(document).ready(function () {

    // Navigation
    let activeItem = document.querySelector('a[href="' + location.href + '"]');

    if (activeItem) {
        activeItem.innerHTML = activeItem.innerHTML + ' <span class="sr-only">(current)</span>';

        if (activeItem.classList.contains('dropdown-item'))
            activeItem.classList.add('active');
        else
            activeItem.parentElement.classList.add('active');
    }


    // Links als aktiv markieren
    let bodyId = $('body').attr('id');
    $('#nav-'+bodyId).addClass('active');

    // Popovers
    $(function () {
        $('[data-toggle="popover"]').popover();
        $('[data-toggle="tooltip"]').tooltip();
    });

    $('.accordion').click(function(){
        if($(this).hasClass('open')){
            $(this).removeClass('open');
        } else {
            $(this).addClass('open');
        }
    })

    // Accordions
    // let accordions = document.getElementsByClassName('accordion');
    // for (let i = 0; i < accordions.length; i++) {
    //     let accordion = accordions[i];
    //
    //     if(!accordion.classList.contains('bootstrap-accordion') && !accordion.classList.contains('open')) {
    //         accordion.querySelector('.accordion-header').addEventListener('click', function() {
    //             let radio = accordion.querySelector('.accordion-header input[type="radio"]');
    //             let wasActive = accordion.classList.contains("active");
    //
    //             console.log(wasActive);
    //             console.log("Hier");
    //
    //             if (accordion.classList.contains("accordion-single")) {
    //                 for (let j = 0; j < accordions.length; j++) {
    //                     accordions[j].classList.remove('active');
    //
    //                     if (radio) {
    //                         radio.removeAttribute("checked");
    //                     }
    //                 }
    //                 if (wasActive) return;
    //
    //                 accordion.classList.add('active');
    //
    //                 if (radio) {
    //                     radio.setAttribute("checked", "");
    //                 }
    //             } else {
    //                 accordion.classList.toggle('active');
    //             }
    //
    //             console.log(accordion.classList.contains('active'));
    //         });
    //     }
    // }

    /*
    // github: cferdinandi/smooth-scroll
    var scroll = new SmoothScroll('a[href*="#"]', {

        // Selectors
        ignore: '[data-scroll-ignore]', // Selector for links to ignore (must be a valid CSS selector)
        header: '#navbar', // Selector for filoxed headers (must be a valid CSS selector)
        topOnEmptyHash: true, // Scroll to the top of the page for links with href="#"

        // Speed & Duration
        speed: 500, // Integer. Amount of time in milliseconds it should take to scroll 1000px
        speedAsDuration: false, // If true, use speed as the total duration of the scroll animation
        durationMax: null, // Integer. The maximum amount of time the scroll animation should take
        durationMin: null, // Integer. The minimum amount of time the scroll animation should take
        clip: true, // If true, adjust scroll distance to prevent abrupt stops near the bottom of the page
        offset: 50,

        // Easing
        easing: 'easeInOutCubic', // Easing pattern to use

        // History
        updateURL: true, // Update the URL on scroll
        popstate: true, // Animate scrolling with the forward/backward browser buttons (requires updateURL to be true)
    });
    */
});


// DISPLAY CONTENT
setTimeout(function () {
    if (document.getElementsByClassName('app-loading').length > 0)
        document.getElementsByClassName('app-loading')[0].classList.remove('app-loading');
}, 200);
